export default {
  '& .oc-expandable-content': {
    padding: '10px',
    display: 'flex',
    backgroundColor: '#f6f6f6',
    alignItems: 'center',

    '&__button': {
      marginLeft: 'auto',
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
    },

    '&__expanded': {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '1200',
      height: '100%',
      margin: 0,
    },

    '&__button-label': {
      fontWeight: 700,
      fontSize: '1rem',
      color: '#271a38',
      textDecoration: 'none',
    },
  },
};
